import { useQueryClient } from "@tanstack/react-query";
import type { FunctionComponent } from "react";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar/Sidebar";
import {
	STAFF_MEMBERS_BONUSES_QUERY_KEY,
} from "~/modules/humanResources/api/staffMemberBonus/staffMemberBonusQueries.ts";
import CreateBonusEntryForm
	from "~/modules/humanResources/components/StaffMemberDetailsView/components/StaffMemberPaymentsSection/components/BonusesSection/components/CreateBonusEntrySidebar/components/CreateBonusEntryForm";

type Props = {
	isOpen: boolean;
	onClose: () => void;
	staffMemberId: string;
};

const CreateBonusEntrySidebar: FunctionComponent<Props> = ({
	isOpen,
	onClose,
	staffMemberId,
}) => {

	const queryClient = useQueryClient();
	const handleSuccess = useCallback(async () => {
		await queryClient.refetchQueries({ queryKey: STAFF_MEMBERS_BONUSES_QUERY_KEY(staffMemberId) });
		onClose();
	}, [onClose, queryClient, staffMemberId]);

	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={() => onClose()}>
			<CreateBonusEntryForm
				key={isOpen ? "open" : "closed"}
				onSuccess={handleSuccess}
				onCancel={onClose}
				staffMemberId={staffMemberId} />
		</Sidebar>
	);
};

export default CreateBonusEntrySidebar;
